import { render } from "./MellonWebECRIntentStatusLabel.vue?vue&type=template&id=577e2074"
import script from "./MellonWebECRIntentStatusLabel.vue?vue&type=script&lang=js"
export * from "./MellonWebECRIntentStatusLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__